import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { useResizablePanel } from '../../context/resizable-panel-context';

const Container = styled.div<{ sidebarWidth: number; overflow: boolean }>`
  display: grid;
  grid-template-columns: ${({ sidebarWidth }) =>
    `${sidebarWidth}px 2px calc(100% - ${sidebarWidth}px)`};
  height: 100%;
  overflow: inherit;
  overflow: ${({ overflow }) => (overflow ? 'inherit' : 'hidden')};
`;

const Sidebar = styled.div`
  background: ${({ theme }) => theme.folderTreeV2.searchBarBg};
  height: 100%;
  overflow: auto;
`;

const Divider = styled.div`
  width: 2px;
  background: ${({ theme }) => theme.resizablePanel.dividerBg};
  cursor: col-resize;
  height: 100%;
  user-select: none;
`;

const MainArea = styled.div<{ overflow: boolean }>`
  height: 100%;
  position: relative;
  overflow: ${({ overflow }) => (overflow ? 'inherit' : 'hidden')};
`;

const MainContent = styled.div`
  min-width: 0px;
  height: 100%;
`;

type LayoutProps = {
  sidebar: ReactNode;
  main: ReactNode;
  sidebarOverflow?: boolean;
  mainContentOverflow?: boolean;
};

const withResizableLayout = (createLayout: () => LayoutProps) => {
  const LayoutWrapper: React.FC = () => {
    const { sidePanelWidth, getDividerProps } = useResizablePanel();

    const { sidebar, main, sidebarOverflow = false, mainContentOverflow = false } = createLayout();

    return (
      <Container sidebarWidth={sidePanelWidth} overflow={sidebarOverflow}>
        <Sidebar>{sidebar}</Sidebar>
        <Divider {...getDividerProps()} />
        <MainArea overflow={mainContentOverflow}>
          <MainContent>{main}</MainContent>
        </MainArea>
      </Container>
    );
  };

  return LayoutWrapper;
};

export default withResizableLayout;
